// extracted by mini-css-extract-plugin
export var divider = "_xq-0";